import { render, staticRenderFns } from "./LocalidadeFilter.vue?vue&type=template&id=72783384&scoped=true"
import script from "./LocalidadeFilter.vue?vue&type=script&lang=js"
export * from "./LocalidadeFilter.vue?vue&type=script&lang=js"
import style0 from "./LocalidadeFilter.vue?vue&type=style&index=0&id=72783384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72783384",
  null
  
)

export default component.exports